import { Link } from "react-router-dom";
import SectionHeader from "./SectionHeader";
import { COLUMNS } from "@/mocks/site";
import { storiesOfColumn } from "@/lib/content";

export default function ColumnSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeader
        eyebrow="栏目地图"
        title="五大栏目 · 按口味下瓜"
        desc="恋爱甜瓜、表白现场、分手复盘、情侣纠纷、三角纠葛，点击任一口味即可进入专属瓜田。"
      />
      <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5 lg:grid-cols-5">
        {COLUMNS.map((c, idx) => {
          const count = storiesOfColumn(c.slug).length;
          return (
            <Link
              key={c.slug}
              to={`/column/${c.slug}`}
              className="group relative block overflow-hidden rounded-xl md:first:col-span-2 md:first:row-span-2 md:first:h-auto"
              title={`${c.name} - 大学吃瓜`}
            >
              <div className={`aspect-[4/5] w-full overflow-hidden ${idx === 0 ? "lg:aspect-[4/6]" : ""}`}>
                <img
                  src={c.image}
                  alt={c.name}
                  title={`${c.name} - 大学吃瓜`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <span className="font-heading text-xs tracking-wide text-secondary-200 uppercase">{c.en}</span>
                <h3 className="mt-1 font-heading text-lg font-black text-background-50">{c.name}</h3>
                <p className="mt-1 hidden text-xs text-background-200/90 sm:block">{c.tagline}</p>
                <div className="mt-3 flex items-center justify-between text-xs text-background-200">
                  <span>{count} 篇新瓜</span>
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-background-50/20 backdrop-blur transition-all group-hover:bg-primary-500">
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}